// extracted by mini-css-extract-plugin
export var modalFooter = "_qw-0";